import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Socket } from 'ngx-socket-io';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';
import { SocketService } from '../services/socket.service';
import { NgxHowlerService } from 'ngx-howler';
import swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import * as Global from 'src/app/global';
import { UserService } from '../services/user.service';
import { CustomService } from '../services/custom.service';
import { SseService } from '../services/sse.service';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css'],
})
export class MainLayoutComponent implements OnInit {
  userDetails: any = null;
  elem: any;
  serverTime: any;
  user$: Observable<any> = this.authService.user$;
  readonly defaultAvatar = 'assets/img/avter.png';

  constructor(
    public authService: AuthService,
    private socketService: SocketService,
    private socket: Socket,
    private toastr: ToastrService,
    private router: Router,
    private howl: NgxHowlerService,
    private spinner: NgxSpinnerService,
    private userService: UserService,
    private customService: CustomService,
    private sseService: SseService,
  ) {}

  ngOnInit(): void {
    this.userDetails = this.authService.getUserSessionDetails();
    this.elem = document.documentElement;
    this.socketService.getErrorResponse();
    this.sseService.connect(this.userDetails?._id).subscribe((event: any) => {
      console.log('SSE EVENT:', event);

      if (event.type === 'passwordChanged') {
        this.authService.userLogout();

        // Do whatever you need here
        // Example:
        // this.loadUser();
        // this.showSuccessMessage(event.data.message);
      } else if (event.type === 'markedError') {
        this.customService.onMarkedError$.next(event.data);
      } else if (event.type === 'updateProfile') {
        this.customService.updateUserProfile$.next(event.data);
      }
    });

    this.socket.on('buyerCloseRequestReceived', (res: any) => {
      if (res?.status == 'success') this.buyerCloseRequestReceived(res?.data);
    });

    this.socket.on('saleExtended', (res: any) => {
      if (this.userDetails?.role == 'buyer') {
        this.extendedTimeSheet(res);
      }
    });

    this.socket.on('priceIdeaReduceSound', (res: any) => {
      if (this.userDetails?.role == 'buyer') {
        //this.howl.get('notify').play();
      }
    });

    // this.socket.on('lotActiveSound', (res: any) => {
    //   console.log('ss1',res);
    //   this.howl.get('notify').play();
    // })
    // this.customService.timer.subscribe(res=>{
    //   this.serverTime = res;
    // })

    this.socket.on('serverTime', (res: any) => {
      this.serverTime = res?.useservertime;
      //this.customService.timer.next(this.serverTime)
      //console.log('debayan serverTime', this.serverTime);
      //  / console.log('debayan serverTime : '+new Date(this.serverTime));
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
      }

      if (event instanceof NavigationEnd) {
        if (document.getElementsByClassName('bd_dropdown')[0])
          document.getElementById('dropdownleftmenu')?.click();
      }
    });

    /**
     * START OF ASSIGNING SOUNDS LIST
     * ------------------------------
     */

    this.howl
      .register('notify', {
        src: ['assets/sounds/notify.mp3'],
        html5: true,
      })
      .subscribe((value) => {});

    /**
     * END OF ASSIGNING SOUNDS LIST
     * ----------------------------
     */

    // this.checkServerSyncTime();
    // this.router.events.subscribe(event => {
    //     if (event instanceof NavigationEnd) {
    //         this.checkServerSyncTime();
    //     }
    // });
  }

  showMe: boolean = false;
  toogleTag() {
    this.showMe = !this.showMe;
  }

  exitfullscreen() {
    document.body.classList.remove('fullscreen');
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (this.elem.mozCancelFullScreen) {
      /* Firefox */
      this.elem.mozCancelFullScreen();
    } else if (this.elem.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitExitFullscreen();
    } else if (this.elem.msExitFullscreen) {
      /* IE/Edge */
      this.elem.msExitFullscreen();
    }
  }
  buyerCloseRequestReceived(request: any) {
    if (['buyer'].includes(this.userDetails?.role)) {
      let exists = (request?.buyerdetails ?? []).findIndex((obj: any) => {
        return obj.user_id == this.userDetails?._id;
      });

      if (exists >= 0) {
        //this.howl.get('notify').play();
        swal
          .fire({
            title: `Request to close offer sheet ${request?.sheetdetails?.sheet_no ?? '-'} immediately`,
            text: `Go to ${request?.sheetdetails?.sheet_no ?? '-'} and click close offer sheet or click accept`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: 'Go',
          })
          .then((result) => {
            if (result.value) {
              this.spinner.show();
              this.socketService.buyerCloseSheetRequestAccept({
                sheet_no: request?.sheetdetails?.sheet_no,
              });

              this.socketService
                .onBuyerCloseSheetRequestAccept()
                .then((res: any) => {
                  this.spinner.hide();
                  if (res.status == 'success') {
                    this.router.navigate([
                      `/dashboard/buyer/offer-sheet/closed/${request?.sheetdetails?.sheet_no}/details`,
                    ]);
                  } else {
                    this.toastr.error(res?.message);
                  }
                })
                .catch((err) => {
                  //this.toastr.error(Global.getServerErrorMessage(err));
                  this.spinner.hide();
                });
            } else {
              this.router.navigate([
                `/dashboard/buyer/offer-sheet/active/${request?.sheetdetails?.sheet_no}/details`,
              ]);
            }
          });
      }
    }
  }

  extendedTimeSheet(res: any) {
    swal
      .fire({
        title: `Sale extended for sheet no - ` + res,
        text: `
              Please click on refresh and continue
              `,
        iconHtml: '<img src="assets/img/clock-error.png">',
        icon: 'warning',
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: 'Refresh',
        cancelButtonText: '',
        customClass: { container: 'clockerror-swal' },
      })
      .then(
        function () {
          location.reload();
        },
        function (dismiss) {
          if (dismiss == 'cancel') {
          }
        },
      );
  }
  onLogoError(event: Event) {
    const img = event.target as HTMLImageElement;
    if (!img.src.endsWith(this.defaultAvatar)) {
      img.src = this.defaultAvatar;
    }
  }
}
